import React, { FC, ReactElement } from 'react';
import cn from 'classnames';

export enum ButtonSize {
  sm = 'fs-caption-reg h-[32px]',
  md = 'fs-caption-reg h-[36px]',
  lg = 'fs-caption-reg h-[38px]',
  xl = 'fs-caption-reg h-[60px]',
  base = 'fs-caption-reg'
}

const buttonSizePadding = {
  [ButtonSize.sm]: 'px-[10px]',
  [ButtonSize.md]: 'px-[14px]',
  [ButtonSize.lg]: 'px-[14px]',
  [ButtonSize.xl]: 'px-[92px]',
  [ButtonSize.base]: ''
};

export enum ButtonColor {
  gray = 'bg-wildSand text-astronautBlue hover:bg-opacity-50 hover:text-wildSand hover:bg-astronautBlue',
  blue = 'bg-astronautBlue text-white hover:bg-vermilion',
  whiteBlue = 'bg-white text-astronautBlue border-2 border-astronautBlue hover:bg-astronautBlue hover:text-white hover:border hover:border-l-white active:bg-prussianBlue',
  whiteVermilion = 'bg-white text-vermilion border border-vermilion hover:bg-vermilion hover:text-white',
  vermilion = 'bg-vermilion text-white hover:bg-astronautBlue'
}

interface Props {
  onClick?: (
    event?: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>
  ) => void;
  label?: string | ReactElement;
  className?: string;
  innerClassName?: string;
  isLoading?: boolean;
  disabled?: boolean;
  children?: string | JSX.Element;
  size?: ButtonSize;
  color: ButtonColor;
  withInnerPadding?: boolean;
  type?: 'submit' | 'reset' | 'button' | undefined;
}

const ButtonBase: FC<Props> = ({
  label,
  onClick,
  className = '',
  innerClassName = '',
  disabled = false,
  size = ButtonSize.base,
  children,
  color,
  withInnerPadding = true,
  type = 'button',
  ...otherProps
}) => {
  return (
    <div className={className}>
      <button
        className={cn(
          'flex w-full items-center justify-center ms-button  uppercase rounded-md ',
          disabled && 'cursor-not-allowed',
          size,
          color,
          innerClassName,
          withInnerPadding && buttonSizePadding[size]
        )}
        type={type}
        onClick={onClick}
        disabled={disabled}
        {...otherProps}
      >
        {children || label}
      </button>
    </div>
  );
};

export default ButtonBase;
